import { render, staticRenderFns } from "./retailer-dstr-list.vue?vue&type=template&id=65170f0a"
import script from "./retailer-dstr-list.vue?vue&type=script&lang=js"
export * from "./retailer-dstr-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports